'use client';

import { useState } from 'react';

interface Props {
  src: string;
  alt: string;
  width: number;
  height: number;
  className?: string;
  style?: React.CSSProperties;
}

export default function PlantImage({ src, alt, width, height, className = '', style }: Props) {
  const [errored, setErrored] = useState(false);

  if (errored) {
    return (
      <div
        className={className}
        style={{ width, height, background: '#ffffff', ...style }}
        aria-label={alt}
      />
    );
  }

  return (
    // eslint-disable-next-line @next/next/no-img-element
    <img
      src={src}
      alt={alt}
      width={width}
      height={height}
      loading="eager"
      onError={() => setErrored(true)}
      className={className}
      style={{ objectFit: 'contain', ...style }}
    />
  );
}
